import { render, staticRenderFns } from "./ModalVerCostos.vue?vue&type=template&id=4d420e14&"
import script from "./ModalVerCostos.vue?vue&type=script&lang=ts&"
export * from "./ModalVerCostos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports